import { DatabaseOutlined } from '@ant-design/icons';
import { useGetArchivedSubmissionsCount } from '@framework/api-client';
import { useCurrentUser } from '@framework/auth';
import { t } from '@framework/i18n';
import { LoaderSpin, useHistory } from '@framework/ui';
import { Button } from 'antd';

export interface ArchivedSubmissionsLinkButtonProps {}

export function ArchivedSubmissionsLinkButton(
  props: ArchivedSubmissionsLinkButtonProps,
) {
  const user = useCurrentUser();
  const history = useHistory();
  const count = useGetArchivedSubmissionsCount({
    query: { enabled: user != null },
  });

  if (count.isLoading) {
    return <LoaderSpin size="small" noPadding />;
  }

  if (!count.data?.count) {
    return null;
  }

  return (
    <Button
      icon={<DatabaseOutlined />}
      onClick={() => history.push('/richieste/archiviate')}
    >
      {t('menu.istanze-archiviate', 'Istanze Archiviate')}
    </Button>
  );
}
